import { Col, Row } from '@maternity/mun-layout';
import * as React from 'react';

export function Ruler() {
  return (
    <Row>
      <Col lg={8} lgOffset={2}>
        <hr />
      </Col>
    </Row>
  );
}
